import { BaseHttpService } from './../../../../shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FileUploadSummaryComponent } from './file-upload-summary.component';

@Injectable({
  providedIn: 'root'
})
export class FileUploadSummaryModalService {

  constructor(
    private readonly dialog: MatDialog
  ) { }

  showModal() {
    let dialogRef: MatDialogRef<FileUploadSummaryComponent>;

    dialogRef = this.dialog.open(FileUploadSummaryComponent, {
      disableClose: true,
      width: '90vw',
      height: '90vh'
    });

    return dialogRef;
  }
}
